module.exports = __webpack_public_path__ + "static/media/heart_icon.eb99d664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart_icon.svg
// module id = 166
// module chunks = 0